import React from 'react';
import PropTypes from 'prop-types';
import { getDismissKey, getStoredDismiss, getAdjustTrackerForTrial, ACQ_Banner_Suppression, SITEWIDE_ADJUST_TRACKERS, ADJUST_BASE_UNIVERSAL_LINK, getRequestId, trackInteraction, trackError, setStoredDismiss, DISMISS_DURATION_24_HRS, isSafari, SafariLogo, ChromeLogo } from '@zillow/app-upsell-utils';
import { shouldRender, HOME_PAGE_UPSELL_ID, setDismiss } from '@zillow/app-upsell-dismiss-store';
import { yieldCallback } from '@zillow/yield-callback';
import 'lodash/get';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _jsxFileName$1 = "/builds/zillow/app-acquisition/home-page-app-upsell/src/components/withExperimentation.js";

var withExperimentation = function withExperimentation(WrappedComponent) {
  var UpsellComponent = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(UpsellComponent, _React$Component);

    function UpsellComponent(props) {
      var _this;

      _this = _React$Component.call(this, props) || this;
      var requestId = getRequestId();
      _this.state = {
        requestId: requestId,
        render: false
      };
      _this.shouldShow = _this.shouldShow.bind(_assertThisInitialized(_this));
      _this.getStoredDismissTimestamp = _this.getStoredDismissTimestamp.bind(_assertThisInitialized(_this));
      return _this;
    }

    var _proto = UpsellComponent.prototype;

    _proto.componentDidMount = function componentDidMount() {
      var _this2 = this;

      shouldRender(HOME_PAGE_UPSELL_ID, 50).then(function (result) {
        _this2.setState({
          render: result
        });
      }).catch(function (error) {
        // const errorMessage = error && error.message;
        // const { requestId } = this.state;
        // trackError({ ...this.props, requestId, actionType: 'store_error', errorMessage })
        // homepage delays rendering of page frame for 5000ms so fallback to old method
        var timeStamp = _this2.getStoredDismissTimestamp();

        var render = _this2.shouldShow(timeStamp);

        _this2.setState({
          render: render
        });
      });
    };

    _proto.shouldShow = function shouldShow(dismissed) {
      if (dismissed) {
        return Date.now() > dismissed;
      }

      return true;
    };

    _proto.getStoredDismissTimestamp = function getStoredDismissTimestamp() {
      var abs = this.props.abs;
      var dismissKey = getDismissKey(abs);
      return getStoredDismiss(dismissKey);
    };

    _proto.getSocialMentionsText = function getSocialMentionsText() {
      return this.state.iOS ? '4.3M Ratings' : null;
    };

    _proto.getAdjustTracker = function getAdjustTracker() {
      var abs = this.props.abs;
      var adjustTracker = 'rw2qau8_ra7mjoq';
      adjustTracker = getAdjustTrackerForTrial(abs, ACQ_Banner_Suppression, SITEWIDE_ADJUST_TRACKERS) || adjustTracker;
      return adjustTracker;
    };

    _proto.getAdjustDeepLinkUrl = function getAdjustDeepLinkUrl() {
      var adjustTracker = this.getAdjustTracker();
      var requestId = this.state.requestId;
      return ADJUST_BASE_UNIVERSAL_LINK + "?requestid=" + requestId + "&adj_t=" + adjustTracker;
    };

    _proto.getUpsellProps = function getUpsellProps() {
      var abs = this.props.abs;
      var dismissKey = getDismissKey(abs);
      var cta = 'Open App';
      var socialMentions = this.getSocialMentionsText();
      var adjustTracker = this.getAdjustTracker();
      var trackerUrl = this.getAdjustDeepLinkUrl();
      var requestId = this.state.requestId;
      return Object.assign({}, this.props, {
        dismissKey: dismissKey,
        requestId: requestId,
        cta: cta,
        socialMentions: socialMentions,
        adjustTracker: adjustTracker,
        trackerUrl: trackerUrl
      });
    };

    _proto.render = function render() {
      var render = this.state.render;
      var upsellProps = this.getUpsellProps();

      if (render) {
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, upsellProps, {
          __self: this,
          __source: {
            fileName: _jsxFileName$1,
            lineNumber: 99,
            columnNumber: 21
          }
        }));
      }

      return null;
    };

    return UpsellComponent;
  }(React.Component);

  UpsellComponent.propTypes = process.env.NODE_ENV !== "production" ? {
    abs: PropTypes.object,
    geoIpLocation: PropTypes.object
  } : {};
  return UpsellComponent;
};

var UPSELL_RENDERED_CLASS = 'homepage-app-upsell';

/**
 * Adds class to body and documentElement.
 * @kind function
 * @param {Array} globalClasses
 *                   global classes to be added
 */

var addGlobalClass = function addGlobalClass(globalClasses) {
  var _document$body$classL;

  if (globalClasses === void 0) {
    globalClasses = [];
  }

  (_document$body$classL = document.body.classList).add.apply(_document$body$classL, _toConsumableArray(globalClasses));
};
/**
 * Removes class from body and documentElement.
 * @kind function
 * @param {Array} globalClasses
 *                   global classesto be removed
 */

var removeGlobalClass = function removeGlobalClass(globalClasses) {
  var _document$body$classL2;

  if (globalClasses === void 0) {
    globalClasses = [];
  }

  (_document$body$classL2 = document.body.classList).remove.apply(_document$body$classL2, _toConsumableArray(globalClasses));
};

var _jsxFileName = "/builds/zillow/app-acquisition/home-page-app-upsell/src/components/withHandlers.js";

var withHandlers = function withHandlers(WrappedComponent) {
  var HandledComponent = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(HandledComponent, _React$Component);

    function HandledComponent(props) {
      var _this;

      _this = _React$Component.call(this, props) || this;
      _this.dismissUpsell = yieldCallback(function () {
        _this.setState({
          dismissed: true
        });

        removeGlobalClass([UPSELL_RENDERED_CLASS]);
        setDismiss(HOME_PAGE_UPSELL_ID, Date.now(), 5000).then(function (result) {
          var upsellProps = Object.assign({}, _this.props, {
            days: result.days
          });
          trackInteraction(Object.assign({}, upsellProps, {
            actionType: 'Clicks_Mweb'
          }));
        }).catch(function (error) {
          var errorMessage = error && error.message;
          trackError(Object.assign({}, _this.props, {
            actionType: 'store_error',
            errorMessage: errorMessage
          }));
          trackInteraction(Object.assign({}, _this.props, {
            actionType: 'Clicks_Mweb',
            errorMessage: errorMessage
          }));
          setStoredDismiss(_this.props.dismissKey, Date.now() + DISMISS_DURATION_24_HRS);
        });
      });
      _this.navigateToAdjust = yieldCallback(function () {
        var trackerUrl = _this.props.trackerUrl;
        trackInteraction(Object.assign({}, _this.props, {
          actionType: 'Clicks_Install'
        }));

        _this.setState({
          dismissed: true
        });

        removeGlobalClass([UPSELL_RENDERED_CLASS]);
        window.location.href = trackerUrl;
      });
      _this.state = {
        dismissed: false,
        isSafari: isSafari()
      };
      _this.dismissUpsell = _this.dismissUpsell.bind(_assertThisInitialized(_this));
      _this.navigateToAdjust = _this.navigateToAdjust.bind(_assertThisInitialized(_this));
      return _this;
    }

    var _proto = HandledComponent.prototype;

    _proto.componentDidMount = function componentDidMount() {
      addGlobalClass([UPSELL_RENDERED_CLASS]);
    } // eslint-disable-next-line zillow/react/sort-comp
    ;

    _proto.render = function render() {
      var adjustTracker = this.props.adjustTracker;
      var dismissed = this.state.dismissed;
      var webLogo;
      var webCopy;

      if (this.state.isSafari) {
        webLogo = /*#__PURE__*/React.createElement(SafariLogo, {
          style: {
            height: '36px'
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 73,
            columnNumber: 27
          }
        });
        webCopy = 'Safari';
      } else {
        webLogo = /*#__PURE__*/React.createElement(ChromeLogo, {
          style: {
            height: '36px'
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 76,
            columnNumber: 27
          }
        });
        webCopy = 'Chrome';
      }

      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
        dismissed: dismissed,
        adjustTracker: adjustTracker,
        webLogo: webLogo,
        webCopy: webCopy,
        dismissUpsell: this.dismissUpsell,
        navigateToAdjust: this.navigateToAdjust,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 80,
          columnNumber: 17
        }
      }));
    };

    return HandledComponent;
  }(React.Component);

  HandledComponent.propTypes = process.env.NODE_ENV !== "production" ? {
    adjustTracker: PropTypes.string.isRequired,
    trackerUrl: PropTypes.string.isRequired,
    dismissKey: PropTypes.string.isRequired
  } : {};
  return HandledComponent;
};

export { withExperimentation, withHandlers };
